<template>
  <div>
        <div class="home" v-if="!maintenanceWindow">
            <TopNavBar v-on:toggle-star="starForm=!starForm"
                       v-on:toggle-pair="pairForm=!pairForm"
                       v-on:toggle-singular="singularForm=!singularForm"
                       v-on:set-star="shortformPlaceholder='star'"
                       v-on:set-colon="shortformPlaceholder='colon'"
                       v-on:set-lowdash="shortformPlaceholder='lowdash'"
                       v-on:set-slash="shortformPlaceholder='slash'"
            />
            <Login v-if="!isLoggedIn()"/>
            <b-container fluid="true" class="content"  style="min-height: calc(~'100vh - 30px');">
                <b-row  align-h="center">
                    <b-col class="col-0 col-sm-0 col-md-1 col-lg-2 p-2"></b-col>
                        <List
                          class="col-12 col-sm-12 col-md-10 col-lg-8"
                          style="min-width: 250px;"
                          v-if="isLoggedIn()"
                          v-bind:starForm="starForm"
                          v-bind:pairForm="pairForm"
                          v-bind:singularForm="singularForm"
                          v-bind:shortformPlaceholderMenu="shortformPlaceholder"
                        />
                    <b-col class="col-0 col-sm-0 col-md-1 col-lg-2 p-2"></b-col>
                </b-row>
            </b-container>
              <GenderAppFooter style="min-height: 30px"/>
        </div>
        <div class="home" v-if="maintenanceWindow">
            <MaintenanceWindow style="min-height: calc(~'100vh - 30px');"/>
            <GenderAppFooter style="min-height: 30px"/>
        </div>
  </div>
</template>

<script>
import List from './List'
import GenderAppFooter from '@/components/Footer'
import Login from '@/views/auth/Login'
import TopNavBar from '@/components/TopNavBar'
import { MAINTENANCE_WINDOW } from '@/env'
import MaintenanceWindow from '@/components/MaintenanceWindow'
var Vue = require('vue')
export default {
  name: 'App',
  components: {
    MaintenanceWindow,
    List,
    Login,
    TopNavBar,
    GenderAppFooter
  },
  data () {
    return {
      starForm: true,
      pairForm: true,
      singularForm: true,
      maintenanceWindow: false,
      shortformPlaceholder: ''
    }
  },
  computed: {
  },
  created () {
    this.maintenanceWindow = MAINTENANCE_WINDOW === 'true'
  },
  mounted () {
  },
  methods: {
    toggleStar () {
      this.starForm = false
      this.$forceUpdate()
    },
    isLoggedIn () {
      if (this.isOutdatedAnonymousUser()) this.resetAuthData()
      const token = Vue.default.cookie.get('token')
      if (!token) {
        const localStorageToken = localStorage.getItem('genderAppToken')
        return !!localStorageToken
      }
      return !!token
    },
    isOutdatedAnonymousUser () {
      let username = Vue.default.cookie.get('username')
      if (!username) username = localStorage.getItem('genderAppUsername')
      if (username !== 'anonymous') return false
      const lastLogin = localStorage.getItem('genderAppLastLogin')
      if (lastLogin === this.today()) return false
      return true
    },
    resetAuthData () {
      Vue.default.cookie.set('token', '', { expires: 0 })
      Vue.default.cookie.set('username', '')
      localStorage.removeItem('genderAppUsername')
      localStorage.removeItem('genderAppToken')
    },
    today () {
      const today = new Date()
      return today.toLocaleDateString('de-CH')
    }
  }
}
</script>
<style scoped>

.content {
    flex: auto;
}
</style>
<style>
    @import "./../assets/css/bootstrap.css";
    @import "./../assets/css/bootstrap-vue.css";
    @import "./../assets/css/style.css";
    @import "./../assets/fontawesome/all.css";
</style>
